export default "__VITE_ASSET__7KJFIU0z__"